export enum DeleteRequestStatus {
  Initiated = "initiated",
  InProgress = "in_progress",
  // Deleted from the database, backups retained, restore possible: the trash.
  Stale = "stale",
  Restoring = "restoring",
  Restored = "restored",
  Completed = "completed",
  Error = "error",
  RestoreError = "restore_error",
}

/** Statuses a request can still move out of, so the grid keeps polling. */
export const PENDING_STATUSES: readonly DeleteRequestStatus[] = [
  DeleteRequestStatus.Initiated,
  DeleteRequestStatus.InProgress,
  DeleteRequestStatus.Restoring,
];

export const FAILED_STATUSES: readonly DeleteRequestStatus[] = [
  DeleteRequestStatus.Error,
  DeleteRequestStatus.RestoreError,
];

export interface DeleteRequest {
  id: number;
  targetProperty: number;
  // Denormalised by the API: the rows are deleted by the time the trash is
  // read, so the labels cannot be resolved from the ids any more.
  targetPropertyName: string;
  targetUhCat: number | null;
  targetUhCatName: string | null;
  targetsProperty: boolean;
  requesterName: string;
  createdAt: string;
  terminatedAt: string | null;
  status: DeleteRequestStatus;
  error: string | null;
  epoch: string;
  daysRemaining: number | null;
  canRestore: boolean;
  // Served by the API rather than hardcoded here, so the countdown cannot
  // drift from the rule the cleanup task actually applies.
  retentionDays: number;
}

/** Which entity a delete request targets, as the config declares it. */
export type DeleteTarget = "property" | "uh_cat";

export interface TableImpact {
  table: string;
  scope: string;
  rows: number;
}

export interface Impact {
  tables: TableImpact[];
  totalRows: number;
  dynamicDependencies: string[];
}
